module.exports = __webpack_public_path__ + "img/addval.3f5f5002.png";